// extracted by mini-css-extract-plugin
export default {"cta":"WF-z","disabled":"XF-z"};